module.exports = "/assets/logo_sg_xd-f41327ac499871fe9ddde6147b5d7437.png";